export const mapOptionsOn = {
    zoomControl: true,
    mapTypeControl: false,
    scaleControl: false,
    streetViewControl: false,
    rotateControl: false,
    fullscreenControl: false,
    disableDefaultUi: false,
    styles: [
        {
            stylers: [{ color: '#ffffff' }]
        },
        {
            featureType: 'landscape',
            elementType: 'geometry',
            stylers: [{ color: '#e7e7e7' }]
        },
        {
            elementType: 'labels',
            stylers: [{ visibility: 'simplified' }, { color: '#636363' }]
        },
        {
            elementType: 'labels.icon',
            stylers: [{ visibility: 'off' }]
        }
    ]
};

export const mapOptionsNoControl = {
    zoomControl: false,
    mapTypeControl: false,
    scaleControl: false,
    scrollwheel: false,
    streetViewControl: false,
    rotateControl: false,
    fullscreenControl: false,
    disableDefaultUi: false,
    draggable: false,
    draggableCursor: 'default',
    styles: [
        {
            stylers: [{ color: '#ffffff' }]
        },
        {
            featureType: 'landscape',
            elementType: 'geometry',
            stylers: [{ color: '#e7e7e7' }]
        },
        {
            elementType: 'labels',
            stylers: [{ visibility: 'off' }, { color: '#636363' }]
        },
        {
            elementType: 'labels.icon',
            stylers: [{ visibility: 'off' }]
        }
    ]
};

export const mapOptionsBlackNoControl = {
    zoomControl: false,
    mapTypeControl: false,
    scaleControl: false,
    scrollwheel: false,
    streetViewControl: false,
    rotateControl: false,
    fullscreenControl: false,
    disableDefaultUi: false,
    draggable: false,
    draggableCursor: 'default',
    styles: [
        {
            elementType: 'labels',
            stylers: [
                {
                    visibility: 'off'
                }
            ]
        },
        {
            featureType: 'administrative',
            elementType: 'geometry',
            stylers: [
                {
                    visibility: 'off'
                }
            ]
        },
        {
            featureType: 'administrative.land_parcel',
            stylers: [
                {
                    visibility: 'off'
                }
            ]
        },
        {
            featureType: 'administrative.neighborhood',
            stylers: [
                {
                    visibility: 'off'
                }
            ]
        },
        {
            featureType: 'landscape',
            stylers: [
                {
                    color: '#5a5d5e'
                }
            ]
        },
        {
            featureType: 'poi',
            stylers: [
                {
                    visibility: 'off'
                }
            ]
        },
        {
            featureType: 'road',
            stylers: [
                {
                    color: '#4b4e50'
                }
            ]
        },
        {
            featureType: 'road',
            elementType: 'labels.icon',
            stylers: [
                {
                    visibility: 'off'
                }
            ]
        },
        {
            featureType: 'road.arterial',
            stylers: [
                {
                    visibility: 'off'
                }
            ]
        },
        {
            featureType: 'road.highway',
            elementType: 'labels',
            stylers: [
                {
                    visibility: 'off'
                }
            ]
        },
        {
            featureType: 'road.local',
            stylers: [
                {
                    visibility: 'off'
                }
            ]
        },
        {
            featureType: 'transit',
            stylers: [
                {
                    visibility: 'off'
                }
            ]
        },
        {
            featureType: 'water',
            stylers: [
                {
                    color: '#4b4e50'
                }
            ]
        }
    ]
};
export const mapOptionsOff = {
    zoomControl: true,
    mapTypeControl: false,
    scaleControl: false,
    streetViewControl: false,
    rotateControl: false,
    fullscreenControl: false,
    disableDefaultUi: false,
    styles: [
        {
            stylers: [{ color: '#ffffff' }]
        },
        {
            featureType: 'landscape',
            elementType: 'geometry',
            stylers: [{ color: '#e7e7e7' }]
        },
        {
            elementType: 'labels',
            stylers: [{ visibility: 'off' }, { color: '#636363' }]
        },
        {
            elementType: 'labels.icon',
            stylers: [{ visibility: 'off' }]
        }
    ]
};

export const mapOptionsOnRetailer2 = {
    zoomControl: true,
    mapTypeControl: false,
    scaleControl: false,
    streetViewControl: false,
    rotateControl: false,
    fullscreenControl: false,
    disableDefaultUi: false,
    styles: [
        {
            stylers: [{ color: '#ffffff' }]
        },
        {
            featureType: 'landscape',
            elementType: 'geometry',
            stylers: [{ color: '#e7e7e7' }]
        },
        {
            elementType: 'labels',
            stylers: [{ visibility: 'simplified' }, { color: '#636363' }]
        },
        {
            elementType: 'labels.icon',
            stylers: [{ visibility: 'off' }]
        }
    ]
};
